import React from 'react';
import { TButtonProps, EButtonTypes, EButtonColors } from './type';
import SButton from './style';

const Button = ({
  type = EButtonTypes.Primary,
  color = EButtonColors.Primary,
  outlined = false,
  ...props
}: TButtonProps) => {
  return <SButton type={type} color={color} outlined={outlined} {...props} />;
};

export { EButtonColors, EButtonTypes };
export default Button;
